import { __assign, __rest } from "tslib";
import React from 'react';
import DaModal from './DaModal';
var Modals = function (_a) {
    var _b = _a.modals, modals = _b === void 0 ? [] : _b, rest = __rest(_a, ["modals"]);
    if (modals.length === 0) {
        return null;
    }
    var renderedModals = modals === null || modals === void 0 ? void 0 : modals.map(function (modal, index) { return (React.createElement(DaModal, __assign({ modal: modal }, rest, { key: index }))); });
    return renderedModals ? (
    // Typescript doesn't like us returning arrays for a React.FC return type despite it being totally fine.
    // Context here: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18912
    React.createElement(React.Fragment, null, renderedModals === null || renderedModals === void 0 ? void 0 : renderedModals.map(function (modal, index) { return (React.createElement(React.Fragment, { key: index }, modal)); }))) : null;
};
Modals.displayName = 'Modals';
export default Modals;
//# sourceMappingURL=Modals.js.map